import React from 'react';
import ReactDOM from 'react-dom';
import i18n from './i18n';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import './index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById('root')
);
